<template>
  <div>
    <!-- 评论列表 -->
    <div class="report-list">
      <div v-for="report in reportList" :key="report.id">
        <el-card shadow="hover">
          <Report class="report" :report="report" />
        </el-card>
      </div>
    </div>

    <!-- 评论列表的分页 -->
    <div class="report-list-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="listPagination.pageNo"
        :page-count="listPagination.pageTotalSize"
        :page-size="listPagination.pageSize"
        @current-change="getReportList"
      >
      </el-pagination>
    </div>

    <NewReport
      :scriptId="scriptId"
      @successSendNewReport="getReportList(listPagination.pageNo)"
    />
  </div>
</template>

<script>
import * as queryString from "query-string";

import Report from "./Report";
import NewReport from "./NewReport";

export default {
  props: {
    scriptId: {
      type: String,
      required: true,
    },
  },
  components: {
    Report,
    NewReport,
  },
  data() {
    return {
      reportList: [],
      listPagination: {
        pageNo: 1,
        pageSize: 10,
        pageTotalSize: 0,
      },
    };
  },
  computed: {},
  methods: {
    async getReportList(currentIndex) {
      this.listPagination.pageNo = currentIndex ? currentIndex : 1;

      const response = await this.axios.get(
        queryString.stringifyUrl({
          url: `/api/selectReportById/${this.scriptId}`,
          query: this.listPagination,
        })
      );

      switch (response.data.code) {
        case 200: //发送成功后返回
          {
            const {
              data,
              pageNo,
              pageSize,
              pageTotalSize,
            } = response.data.data;
            this.reportList = data;
            this.listPagination.pageNo = pageNo;
            this.listPagination.pageSize = pageSize;
            this.listPagination.pageTotalSize = pageTotalSize;
          }
          break;

        case -100:
          this.$message({
            message: "反馈获取失败",
            type: "error",
          });
          break;
      }
    },
  },
  mounted() {
    this.getReportList();
  },
};
</script>

<style scoped>
.el-card {
  margin-bottom: 20px;
  min-width: 700px;
}
.report-list-footer {
  display: flex;
  justify-content: center;
}
</style>